// RowActionsMenu.jsx
import React, { useState } from "react";
import { IconButton, Menu, MenuItem } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import PropTypes from "prop-types";
const RowSocietyActionsMenu = ({
  row,
  onEdit,
  onCreateSocietyUser,
  onViewSocietyUsers,
  onViewColleges,
  hasPermission,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleOpen = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const isInactive = row.is_society_active == 0;
  return (
    <>
      <IconButton onClick={handleOpen}>
        <MoreVertIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {!hasPermission("edit") && (
          <MenuItem
            onClick={() => {
              onEdit(row);
              handleClose();
            }}
          >
            Edit Society
          </MenuItem>
        )}
        <MenuItem
          disabled={isInactive}
          onClick={() => {
            onCreateSocietyUser(row.society_id, row.society_name, row.client_id);
            handleClose();
          }}
        >
          Create User
        </MenuItem>
        <MenuItem
          disabled={isInactive}
          onClick={() => {
            onViewSocietyUsers(row.society_id, row.society_name, row.client_id);
            handleClose();
          }}
        >
          View Users
        </MenuItem>
        <MenuItem
          disabled={isInactive}
          onClick={() => {
            onViewColleges(row.society_id, row.society_name, row.client_id);
            handleClose();
          }}
        >
          View Colleges
        </MenuItem>
      </Menu>
    </>
  );
};
RowSocietyActionsMenu.propTypes = {
  row: PropTypes.shape({
    society_id: PropTypes.number.isRequired,
    society_name: PropTypes.string.isRequired,
    client_id: PropTypes.number.isRequired,
    is_society_active: PropTypes.number.isRequired,
  }).isRequired,
  onEdit: PropTypes.func.isRequired,
  onCreateSocietyUser: PropTypes.func.isRequired,
  onViewSocietyUsers: PropTypes.func.isRequired,
  onViewColleges: PropTypes.func.isRequired,
  hasPermission: PropTypes.func.isRequired,
};
export default RowSocietyActionsMenu;
